// removed by extract-text-webpack-plugin
module.exports = {"menu":"_3GdBTRImb-qgLqSV_mVTFi"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/PopoverMenu/PopoverMenu.scss
// module id = ./node_modules/wix-style-react/dist/es/src/PopoverMenu/PopoverMenu.scss
// module chunks = 0